export function translate(
  value: string | Array<string>,
  translations: Record<string, string> = {},
): string | Array<string> {
  if (Array.isArray(value)) {
    return value.map((v) => translations[v] || v).join(', ');
  }
  return translations[value] || value;
}
